module.exports = __webpack_public_path__ + "img/es.d53b3ecf.svg";